













import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class App extends Vue {
  private mounted() {
    // const el: any = document.getElementById('myLoading-mask');
    // console.log(el, 'remove');
    // el.remove();
  }
}
